// Production-owned VerbaSchola visual tokens shared by teacher and student redesigns.
// Legacy routes retain the application theme until they are migrated separately.
export const NAVY = '#163A63';
export const SLATE = '#5E6C84';
export const BLUE = '#2F6FED';
export const BLUE_PRESSED = '#245DCC';
export const BLUE_TEXT = BLUE_PRESSED;
export const GREEN = '#2F8F68';
export const SUCCESS_TEXT = '#24724F';
export const YELLOW = '#F4C95D';
export const YELLOW_HOVER = '#EABF45';
export const PAGE_BACKGROUND = '#F6F8FC';
export const BORDER = '#DFE7F2';
export const INK = '#1E1E1E';
export const ERROR = '#F25555';
export const ERROR_TEXT = '#B42335';
export const WARNING = '#FFBE19';
export const WARNING_TEXT = '#6B531F';

export const NAVIGATION_BACKGROUND = '#EAF0F8';
export const SOFT_BLUE = '#EAF1FD';
export const BLUE_HOVER = '#DDE8FB';
export const PROGRESS_TRACK = '#E9EEF5';
export const SUCCESS_SOFT = '#EAF6F0';
export const ERROR_SOFT = '#FFE5E5';
export const WARNING_SOFT = '#FFE299';
export const SURFACE_MUTED = '#F3F6FA';
export const SURFACE_SUBTLE = '#F7F9FD';
export const SURFACE_TINT = '#FBFCFF';

export const ON_NAVY_ACCENT = '#9ABCF5';
export const ON_NAVY_LABEL = '#AAC5F2';
export const ON_NAVY_MUTED = '#C5D7F2';
export const ON_NAVY_TEXT = '#DCE7F7';

// Reserved for genuine multi-series data visualization.
export const CHART_BLUE = '#2462C7';
export const CHART_PURPLE = '#2A2459';

export const POPPINS = 'Poppins, KaiTi, sans-serif';
export const INTER = 'Inter, KaiTi, sans-serif';

// Pair identity colors match V2; numbers always accompany color.
export const MATCH_PAIR_COLORS = [BLUE_TEXT, "#6B46A5", "#087E8B", "#41418A"] as const;
